module.exports = __webpack_public_path__ + "media/images/mobile/solutions/33-9ddf0baf793248b656341c4d582331b6.png";